module.exports = __webpack_public_path__ + "static/media/wf.9c44b5a0.svg";